import { ReactNode } from 'react';
import styled from 'styled-components';

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: 20% 80%;
  width: 200px;
  min-width: 200;
  min-height: 90px;
  background-color: none;
  border-radius: 15px;
  cursor: pointer;
  transition: transform 0.3s ease; /* Transição suave */

  &:hover {
    transform: scale(1.005); /* Aumenta 5% */
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  }
`;

const CardDetalheLateral = styled.div<{
  $color?: string;
  $iconSize?: string;
  $icon?: ReactNode;
}>`
  background-color: ${(props) => props.$color};
  border-radius: 20px 0 0 20px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${(props) => props.$iconSize || '24px'};
`;

const CardConteudo = styled.div<{ $color?: string }>`
  background-color: white;
  border-radius: 0 15px 15px 0;
  display: grid;
  grid-template-columns: 70% 30%;
  grid-template-rows: auto;
`;

const CardTitulo = styled.div`
  font-size: 1rem;
  text-align: left;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  align-content: center;
  height: 100%;
`;

const CardNumero = styled.div`
  font-size: 2rem;
  text-align: right;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding-right: 20px;
  align-items: center;
  height: 100%;
  color: ${(props) => props.color};
`;

interface CardNumberProps {
  title: string;
  number: string;
  color?: string;
  icon?: ReactNode;
  iconSize?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

function CardNumber({
  title,
  number,
  color,
  icon,
  iconSize,
  onClick,
}: CardNumberProps) {
  return (
    <CardContainer onClick={onClick}>
      <CardDetalheLateral $color={color} $icon={icon} $iconSize={iconSize}>
        {icon}
      </CardDetalheLateral>
      <CardConteudo>
        <CardTitulo>{title}</CardTitulo>
        <CardNumero color={color}>{number}</CardNumero>
      </CardConteudo>
    </CardContainer>
  );
}

export default CardNumber;
